import { OrderFieldsFragment } from '../../graphql';
import { defined } from '../../../utils/defined';
import { Icon } from '../../../Product/components/Icon';

export type IconsProps = React.HTMLAttributes<HTMLDivElement> & {
	items: OrderFieldsFragment['items'];
};

export const Icons: React.FC<IconsProps> = ({ items, className, ...props }) => (
	<div
		className={`d-flex flex-wrap order-icons${
			className ? ` ${className}` : ''
		}`}
		{...props}
	>
		{items
			.map(item => item.item.product)
			.filter(defined)
			.sort((a, b) => a.name.charCodeAt(0) - b.name.charCodeAt(0))
			.map((product, key) => (
				<Icon
					key={key}
					{...product}
					circleImageProps={{
						className: 'mr-2 my-1'
					}}
				/>
			))}
	</div>
);
